import { rosterURL } from '../utils/endpoints';
import RosterSDK from '@nackle/roster-sdk';
import cache from '../utils/cache';

function RosterService( { access_token, claims = {} } ) {

    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'company-id': claims.company_id,
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };

    const sdk = new RosterSDK( rosterURL, fetchWithAuth, cache, undefined, { error: () => false } );

    return {
        getPerson: async ( personId ) => {
            try {
                return await sdk.getPerson( personId );
            } catch {
                return { givenName: '¯\\_(ツ)_/¯', surname: '' };
            }
        },

        getPersonMap: async ( personIds ) => {
            const personMap = {};

            if ( personIds.length > 0 ) {
                const uniquePersonIds = new Set( personIds );
                personIds = Array.from( uniquePersonIds );

                try {
                    const results = await sdk.searchPersons( {
                        pageSize: personIds.length,
                        pageNumber: 1,
                        personIds: personIds.filter( id => !!id )
                    } );

                    results.persons.forEach( person => {
                        personMap[ person.id ] = person;
                    } );
                } finally {
                    personIds.forEach( personId => {
                        if ( !personMap[ personId ] ) {
                            personMap[ personId ] = {
                                givenName: '¯\\_(ツ)_/¯',
                                surname: ''
                            };
                        }
                    } );
                }
            }

            return personMap;
        }
    };
}

export default RosterService;
